module.exports = ".alignTop {\n  margin-top: 1em; }\n"